import React from 'react';

const AccountContainer = () => {
  return <div> AccountContainer Logic</div>;
};

export default AccountContainer;
